import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

export default function StyledTable({ data, isSmall }) {
  return (
    <Paper
      elevation={2}
      sx={{
        p: { xs: 2, sm: 3 },
        borderRadius: 2,
        maxHeight: "auto",
        border: "1px solid",
        borderColor: "divider",
      }}
    >
      <Typography
        variant="h6"
        sx={{
          mb: 2.5,
          fontWeight: 600,
          color: "primary.main",
          borderBottom: "1px solid",
          borderColor: "divider",
          pb: 1,
        }}
      >
        Información del Pedido
      </Typography>
      <TableContainer
        sx={{
          maxHeight: { xs: 250, sm: 300, md: 480 },
          overflowY: "auto",
          paddingRight: { xs: 0, sm: 1 },
          "& .MuiTable-root": {
            borderCollapse: "separate",
            borderSpacing: "0 8px",
          },
        }}
      >
        <Table size={isSmall ? "small" : "medium"}>
          <TableHead>
            <TableRow
              sx={{
                "& .MuiTableCell-head": {
                  fontWeight: "bold",
                  backgroundColor: "rgba(0, 0, 0, 0.04)",
                  borderBottom: "2px solid",
                  borderColor: "primary.light",
                },
              }}
            >
              <TableCell>Producto</TableCell>
              <TableCell>Foto</TableCell>
              <TableCell align="right">Cantidad</TableCell>
              <TableCell align="right">Subtotal</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.OrderItems?.map((item) => (
              <TableRow
                key={item?.id}
                sx={{
                  "&:hover": {
                    backgroundColor: "rgba(0, 0, 0, 0.02)",
                  },
                }}
              >
                <TableCell sx={{ fontWeight: 500 }}>
                  {item?.name}
                  {item?.description && (
                    <Typography
                      variant="caption"
                      component="div"
                      sx={{
                        mt: 0.5,
                        color: "text.secondary",
                        fontSize: "0.75rem",
                      }}
                    >
                      {item.description.split(", ").map((sabor, index) => (
                        <Box key={index}>{sabor.replace("::", ": ")}</Box>
                      ))}
                    </Typography>
                  )}
                </TableCell>
                <TableCell sx={{ fontWeight: 500 }}>
                  <img
                    src={item?.img}
                    alt={item?.name}
                    style={{
                      width: "100%",
                      maxWidth: "65px",
                      height: "auto",
                      aspectRatio: "1/1",
                      borderRadius: 5,
                      objectFit: "cover",
                      objectPosition: "center",
                    }}
                  />
                </TableCell>
                <TableCell align="right">{item?.quantity}</TableCell>
                <TableCell
                  align="right"
                  sx={{
                    fontWeight: "medium",
                    color: "text.primary",
                  }}
                >
                  {item?.subtotal} €
                </TableCell>
              </TableRow>
            ))}
            <TableRow sx={{ backgroundColor: "background.subtle" }}>
              <TableCell colSpan={3} align="right" sx={{ border: 0 }}>
                <Typography variant="body1" sx={{ fontWeight: 500 }}>
                  Costo de envío:
                </Typography>
              </TableCell>
              <TableCell
                align="right"
                sx={{
                  border: 0,
                  fontWeight: "medium",
                }}
              >
                {data?.shipping_cost} €
              </TableCell>
            </TableRow>
            <TableRow sx={{ backgroundColor: "background.subtle" }}>
              <TableCell colSpan={3} align="right" sx={{ border: 0 }}>
                <Typography variant="body1" sx={{ fontWeight: 500 }}>
                  Descuento:
                </Typography>
              </TableCell>
              <TableCell
                align="right"
                sx={{
                  border: 0,
                  fontWeight: "medium",
                }}
              >
                {data?.discount || 0} €
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell
                colSpan={3}
                align="right"
                sx={{
                  border: 0,
                  pt: 1.5,
                }}
              >
                <Typography variant="h6" sx={{ fontWeight: 700 }}>
                  Total:
                </Typography>
              </TableCell>
              <TableCell
                align="right"
                sx={{
                  border: 0,
                  pt: 1.5,
                  color: "primary.main",
                  fontWeight: 700,
                  fontSize: "1.1rem",
                }}
              >
                {data?.total_cost} €
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
}
